let areaData = [
	{
		"ID": 25,
		"TopID": 0,
		"AddName": "四川省"
	},
	{
		"ID": 304,
		"TopID": 25,
		"AddName": "成都市"
	}, 
	{
		"ID": 2871,
		"TopID": 304,
		"AddName": "青羊"
	}, {
		"ID": 2872,
		"TopID": 304,
		"AddName": "金牛"
	}, {
		"ID": 2873,
		"TopID": 304,
		"AddName": "武侯"
	}, {
		"ID": 2874,
		"TopID": 304,
		"AddName": "成华"
	}, {
		"ID": 2875,
		"TopID": 304,
		"AddName": "龙泉驿"
	}, {
		"ID": 2876,
		"TopID": 304,
		"AddName": "青白江"
	}, {
		"ID": 2877,
		"TopID": 304,
		"AddName": "新都"
	}, {
		"ID": 2878,
		"TopID": 304,
		"AddName": "温江"
	}, {
		"ID": 2879,
		"TopID": 304,
		"AddName": "双流"
	}, {
		"ID": 2880,
		"TopID": 304,
		"AddName": "邯郸区"
	}, {
		"ID": 2881,
		"TopID": 304,
		"AddName": "简阳"
	}, {
		"ID": 2882,
		"TopID": 304,
		"AddName": "都江堰"
	}, {
		"ID": 2883,
		"TopID": 304,
		"AddName": "彭州"
	}, {
		"ID": 2884,
		"TopID": 304,
		"AddName": "邛崃"
	}, {
		"ID": 2885,
		"TopID": 304,
		"AddName": "崇州"
	}, {
		"ID": 2886,
		"TopID": 304,
		"AddName": "金堂"
	}, {
		"ID": 2887,
		"TopID": 304,
		"AddName": "大邑"
	}, {
		"ID": 2888,
		"TopID": 304,
		"AddName": "浦江"
	}, {
		"ID": 28880,
		"TopID": 304,
		"AddName": "高新区"
	}, {
		"ID": 28881,
		"TopID": 304,
		"AddName": "天府新区"
	}, {
		"ID": 28882,
		"TopID": 304,
		"AddName": "高新西区"
	}, {
		"ID": 288843,
		"TopID": 304,
		"AddName": "锦江区"
	}
]
	export default areaData
	